import React from "react";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateDataTemplatesForm from "./forms/CreateDataTemplatesForm";
import { FORM_TYPE_ADD } from "../../../_helpers/constants";

export default function CreateDataTemplates() {
     return (
          <>
               <MainLeftTitle title="Create Data Templates"></MainLeftTitle>
               <CreateDataTemplatesForm type={FORM_TYPE_ADD} />
          </>
     );
}
